<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M19.9989 10.3289H13.9723L16.4078 7.82222C13.9811 5.42222 10.0523 5.33333 7.62559 7.73333C5.19892 10.1422 5.19892 14.0267 7.62559 16.4356C10.0523 18.8444 13.9811 18.8444 16.4078 16.4356C17.6167 15.2444 18.2211 13.8489 18.2211 12.0889H19.9989C19.9989 13.8489 19.2167 16.1333 17.6523 17.68C14.5323 20.7733 9.46559 20.7733 6.34559 17.68C3.23447 14.5956 3.20781 9.58222 6.32781 6.49778C9.44781 3.41333 14.4523 3.41333 17.5723 6.49778L19.9989 4V10.3289Z"
      fill="currentColor"
    />
  </svg>
</template>
